export const state = () => {
  return {
      tablesTypesList: [],
      selectedTablesTypesList: [],
      filteredRawTablesTypesObjects: [],
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/rawDataPartnersReport/state.js